import { useCallback, useEffect, useMemo, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './css/overridesquill.css'
import { formats } from './config.js';
import registerBlots from './BlotsRegistration'; // Appelle la fonction pour enregistrer les blots

const QuillEditor = ({ content, onChange, readOnly = false, style }) => {
  const quillRef = useRef();

  // Enregistre les blots une seule fois
  useEffect(() => {
    registerBlots();
  }, []);

  useEffect(() => {
    const quill = quillRef?.current?.getEditor();

    if (quill) {
      // Convertir le contenu HTML en Delta avant de l'appliquer à Quill
      const delta = quill.clipboard.convert(content);
      quill.setContents(delta);
    }
  }, [content]);

  const modules = {
    toolbar: readOnly ? null : {
      container: "#toolbar-container",
    },
  };

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      value={content}
      modules={modules}
      formats={formats}
      onChange={onChange}
      style={style}
      readOnly={readOnly}
    />
  );
};

export default QuillEditor;